import { BasicTooltip, IconLibrary, ThriveIcon } from "thrive-components";

import "../../../../css/global/buttons/nav-button.scss";

interface ITopNavButton {
    ariaLabel: string,
    onButtonClick: any
    iconName: IconLibrary,
    tooltipText: string
}

const NavButton = ({ariaLabel, onButtonClick, iconName, tooltipText}: ITopNavButton) => {

    return (
        <BasicTooltip 
            className="below nav-button-tooltip"
            children={ 
                <button className={`nav-button`}  aria-label={ariaLabel} onClick={onButtonClick} type={'button'}>
                    <ThriveIcon iconName={iconName} sizeInPx="14" color="var(--thriveCharcoal)" />
                </button>
            }
            text={tooltipText}>
         </BasicTooltip>
    );
};

export default NavButton